import { IRMSAuthModel } from 'types/rmsAuthModel'
import { parseJson } from 'utils/utils'
import { CSRF_TOKEN } from './constants'

localStorage.setItem(CSRF_TOKEN, (document.querySelector('#antiForgery input') as HTMLInputElement)?.value)

export const rmsAuthModel = parseJson(document.getElementById('rmsAuthModel')?.innerHTML.trim()) as IRMSAuthModel
